<template>
  <div>
    <v-row justify="center">
      <v-dialog max-width="960px" persistent v-model="dialogForm">
        <v-card>
          <v-toolbar color="tertiary" flat>
            <v-toolbar-title class="text-h6">{{ formTitle }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
            <v-card-text class="pb-0">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" cols="6">
                    <v-autocomplete
                      label="Estados"
                      v-model="formData.estado"
                      :items="estados"
                      :search-input.sync="searchEstadosAutoComplete"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      :aria-autocomplete="false"
                      clearable
                      dense
                      :rules="rules.estado"
                      :error-messages="errors.estado"
                      @change="getCidades"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col class="py-0" cols="6">
                    <v-autocomplete
                      label="Cidades"
                      v-model="formData.cidade_id"
                      :items="cidades"
                      :search-input.sync="searchCidadesAutoComplete"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      :aria-autocomplete="false"
                      clearable
                      dense
                      :rules="rules.cidade_id"
                      :loading="isloadingCidades"
                      :error-messages="errors.cidade_id"
                      @change="getBairros"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="5">
                    <v-autocomplete
                      label="Bairros"
                      v-model="formData.bairro_id"
                      :items="bairros"
                      :loading="isloadingAutoCompleteBairro"
                      :search-input.sync="searchAutoCompleteBairro"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      :aria-autocomplete="false"
                      clearable
                      dense
                      :rules="rules.bairro_id"
                      :error-messages="errors.bairro_id"
                      @change="getLogradouros"
                    >
                      <template v-slot:append-outer>
                        <v-btn color="teal" dark depressed tile @click="toggleBairroForm">
                          <v-icon left>mdi-plus</v-icon>
                          Adicionar
                        </v-btn>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col class="py-0" cols="7" @changelogradouro="getLogradouros">
                    <v-autocomplete
                      label="Logradouros"
                      v-model="formData.logradouro_id"
                      :items="logradouros"
                      :search-input.sync="searchAutoCompleteLogradouro"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      :aria-autocomplete="false"
                      clearable
                      dense
                      :rules="rules.logradouro_id"
                      :error-messages="errors.logradouro_id"
                    >
                      <template v-slot:append-outer>
                        <v-btn color="teal" dark depressed tile @click="toggleLogradouroForm">
                          <v-icon left>mdi-plus</v-icon>
                          Adicionar
                        </v-btn>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="2">
                    <v-text-field
                      :counter="20"
                      :error-messages="errors.numero"
                      :rules="rules.numero"
                      class="pa-0"
                      dense
                      label="Número"
                      outlined
                      v-model="formData.numero"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="3">
                    <v-text-field
                      :counter="10"
                      :error-messages="errors.cep"
                      :rules="rules.cep"
                      class="pa-0"
                      dense
                      label="CEP"
                      v-mask="'#####-###'"
                      outlined
                      v-model="formData.cep"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="7">
                    <v-text-field
                      :counter="200"
                      :error-messages="errors.complemento"
                      :rules="rules.complemento"
                      class="pa-0"
                      dense
                      label="Complemento"
                      outlined
                      v-model="formData.complemento"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-switch v-model="formData.principal" label="Endereço Principal?"> </v-switch>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn @click="toggleForm" color="red" dark depressed>
                <v-icon left small>mdi-close</v-icon>
                Fechar
              </v-btn>
              <v-btn
                :disabled="!valid"
                :loading="isloadingSubmit"
                color="green"
                dark
                depressed
                type="submit"
              >
                <v-icon left small>mdi-send</v-icon>
                Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <bairro-modal-form />
    <logradouro-modal-form />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { max, required } from '@/services/util/validate';
import toastMessage from '@/services/util/alertService';
import cidadeHttp from '@/services/http/resources/configuracao/cidadeHttp';
import bairroHttp from '@/services/http/resources/configuracao/bairroHttp';
import logradouroHttp from '@/services/http/resources/configuracao/logradouroHttp';
import BairroModalForm from '@/views/private/configuracao/bairro/ModalForm.vue';
import LogradouroModalForm from '@/views/private/configuracao/logradouro/ModalForm.vue';
import { mask } from 'vue-the-mask';

export default {
  name: 'ModalEnderecoForm',
  components: { LogradouroModalForm, BairroModalForm },
  directives: {
    mask,
  },
  data: () => ({
    cidades: [],
    bairros: [],
    logradouros: [],
    valid: true,
    formData: {
      estado: '',
      id: '',
      principal: false,
      numero: '',
      complemento: '',
      cep: '',
      cgm_id: '',
      cidade_id: '',
      bairro_id: '',
      logradouro_id: '',
    },
    formDataDefault: {
      estado: '',
      id: '',
      principal: false,
      numero: '',
      complemento: '',
      cep: '',
      cgm_id: '',
      cidade_id: '',
      bairro_id: '',
      logradouro_id: '',
    },
    rules: {
      numero: [(value) => max(value, 20)],
      complemento: [(value) => max(value, 200)],
      bairro_id: [required],
      cidade_id: [required],
      logradouro_id: [required],
      cep: [(value) => max(value, 10)],
    },
    errors: {
      numero: [],
      complemento: [],
      bairro_id: [],
      cidade_id: [],
      logradouro_id: [],
      cep: [],
    },
    isloadingSubmit: false,
    isloadingCidades: false,
    isloadingAutoCompleteBairro: false,
    searchAutoCompleteBairro: '',
    isloadingAutoCompleteLogradouro: false,
    searchAutoCompleteLogradouro: '',
    searchEstadosAutoComplete: '',
    searchCidadesAutoComplete: '',
  }),
  computed: {
    ...mapState('estados', { estados: 'listPluck' }),
    ...mapState('configuracao', ['config']),
    ...mapState('pessoa', ['data']),
    ...mapState('cgmEndereco', {
      dataIndex: 'dataIndex',
      dialogForm: 'dialogForm',
      dataEndereco: 'data',
    }),
    formTitle() {
      return this.dataIndex === -1 ? 'Adicionar Endereço' : 'Editar Endereço';
    },
  },
  created() {
    this.show();
    this.getEstados();
  },
  mounted() {
    this.$bus.$on('checkbairro', this.getBairros);
    this.$bus.$on('checklogradouro', this.getLogradouros);
  },
  methods: {
    ...mapActions('estados', ['list']),
    ...mapActions('configuracao', ['show']),
    ...mapActions('bairro', { toggleBairroForm: 'toggleForm' }),
    ...mapActions('logradouro', { toggleLogradouroForm: 'toggleForm' }),
    ...mapActions('cgmEndereco', [
      'toggleForm',
      'store',
      'update',
      'setDataIndex',
      'clearData',
      'reset',
    ]),
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        const actionHttp = this.dataIndex === -1
          ? this.store(this.formData) : this.update(this.formData);
        actionHttp
          .then(() => {
            toastMessage.successSave('Endereço adicionado na lista.');
          })
          .catch(() => toastMessage.errorSave('Erro ao adicionar endereço na lista.'))
          .finally(() => {
            this.isloadingSubmit = false;
          });
      }
    },
    openDialogForm() {
      this.resetValidation();
      if (this.dataIndex > -1) {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          if (key === 'estado') {
            this.formData[key] = this.config.estado_id;
            this.getCidades();
          } else if (key === 'cidade_id') {
            this.formData[key] = this.config.cidade_id;
            this.getBairros();
          } else if (key === 'bairro_id') {
            this.formData[key] = this.dataEndereco[key];
            this.getLogradouros();
          } else if (key === 'cgm_id') {
            this.formData[key] = this.$route.params.id;
          } else {
            this.formData[key] = this.dataEndereco[key];
          }
        });
      } else {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          if (key === 'estado') {
            this.formData[key] = this.config.estado_id;
            this.getCidades();
          } else if (key === 'cidade_id') {
            this.formData[key] = this.config.cidade_id;
            this.getBairros();
          } else if (key === 'cgm_id') {
            this.formData[key] = this.$route.params.id;
          }
        });
      }
    },
    closeDialogForm() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetValidation();
        this.resetEstadosAutoComplete();
        this.resetCidadesAutoComplete();
        this.resetBairrosAutoComplete();
        this.resetLogradourosAutoComplete();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    getCidades() {
      this.resetCidadesAutoComplete();
      this.resetBairrosAutoComplete();
      this.resetLogradourosAutoComplete();
      if (!this.formData.estado) return;
      this.isloadingCidades = true;
      cidadeHttp
        .listCidades(this.formData.estado)
        .then(({ data: { data } }) => {
          this.cidades = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar cidades'))
        .finally(() => {
          this.isloadingCidades = false;
        });
    },
    getBairros() {
      this.resetBairrosAutoComplete();
      this.resetLogradourosAutoComplete();
      if (!this.formData.cidade_id) return;
      this.isloadingAutoCompleteBairro = true;
      bairroHttp
        .listBairroCidade(this.formData.cidade_id)
        .then(({ data: { data } }) => {
          this.bairros = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar bairros'))
        .finally(() => {
          this.isloadingAutoCompleteBairro = false;
        });
    },
    getLogradouros() {
      this.resetLogradourosAutoComplete();
      if (!this.formData.bairro_id) return;
      this.isloadingAutoCompleteLogradouro = true;
      logradouroHttp
        .listLogradouroBairro(this.formData.bairro_id)
        .then(({ data: { data } }) => {
          this.logradouros = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar logradouros'))
        .finally(() => {
          this.isloadingAutoCompleteLogradouro = false;
        });
    },
    getEstados() {
      if (!this.estados.length) {
        this.list();
      }
    },
    resetEstadosAutoComplete() {
      this.formData.estado = '';
      this.searchEstadosAutoComplete = null;
    },
    resetCidadesAutoComplete() {
      this.cidades = [];
      this.formData.cidade_id = '';
      this.searchCidadesAutoComplete = null;
    },
    resetBairrosAutoComplete() {
      this.formData.bairro_id = '';
      this.bairros = [];
      this.searchAutoCompleteBairro = null;
    },
    resetLogradourosAutoComplete() {
      this.formData.logradouro_id = '';
      this.logradouros = [];
      this.searchAutoCompleteLogradouro = null;
    },
  },
  watch: {
    dialogForm(value) {
      if (value) {
        this.openDialogForm();
      } else {
        this.closeDialogForm();
      }
    },
    'formData.numero': function () {
      this.errors.numero = [];
    },
    'formData.complemento': function () {
      this.errors.complemento = [];
    },
    'formData.bairro_id': function () {
      this.errors.bairro_id = [];
    },
    'formData.cidade_id': function () {
      this.errors.cidade_id = [];
    },
    'formData.logradouro_id': function () {
      this.errors.logradouro_id = [];
    },
    'formData.cep': function () {
      this.errors.cep = [];
    },
  },
  destroyed() {
    this.reset();
  },
};
</script>

<style lang="scss">
.v-input__append-outer {
  .v-btn {
    margin-top: -5px;
  }
}
</style>
